import { formatElapsed, type SavReminder } from '@/services/savRemindersService';

const dayFormatter = new Intl.DateTimeFormat('fr-BE', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Europe/Brussels',
});

/** Libellé d'ancienneté d'un rappel : « Visite le ven. 6 nov., 10:00 » pour les règles de visite, sinon « Depuis 3 j » */
export const savReminderWhen = (
  r: Pick<SavReminder, 'rule_key' | 'visit_at' | 'elapsed_hours'>
): string => {
  if ((r.rule_key === 'visit_eve' || r.rule_key === 'visit_past') && r.visit_at) {
    return `Visite le ${dayFormatter.format(new Date(r.visit_at))}`;
  }
  return `Depuis ${formatElapsed(r.elapsed_hours)}`;
};
